import FormField from './FormField';
import formFieldStyles from './formField.module.scss';

export { FormField, formFieldStyles };

export default FormField;
